export default __webpack_public_path__ + "static/media/tassoazevedo.28dbe3b3.jpeg";